import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export { GUID } from "./guid";
export { Param } from "./param";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		HttpModule,
		BrowserAnimationsModule
	],
	declarations: [
	],
	exports: [
	]
})

export class BrightServeCommonModule {
}



// WEBPACK FOOTER //
// ./src/app/common/brightserve-common.module.ts